export const BASE_FLIRT_URL = process.env.NEXT_PUBLIC_FLIRT_ENDPOINT;
export const SITEMAP_PATH = '/Sitemap/edit.html';
export const ADVISORY_CONTENT_PATH = '/Advisory_Content/edit.html';
export const PROPERTY_EXPLANATIONS_PATH = '/Property_Explanations/edit.html';
export const FILTER_MANAGER_PATH = '/Filters/edit.html';
export const COMPACT_PROPERTIES_PATH = '/Compact_Properties/edit.html';
export const CUSTOM_USPS_PATH = '/Custom_USPs/edit.html';
export const PRODUCT_COLLECTIONS_PATH = '/Nicolle_Collections/edit.html';
export const CONFIGURATOR_PATH = '/Configurator/edit.html';
export const ACCESSORY_CATEGORY_PATH = '/Accessory_Categories_Manager/edit.html';
export const PRODUCT_OVERRIDES_PATH = '/Product_Overrides/edit.html';
export const PRODUCT_WIZARD_PATH = '/ProductWizard/edit.wizardproductmanagemodel.wizard.html';
export const PRODUCT_IMAGE_GALLERY_PATH =
  '/Product_Image_Gallery/edit.productimagegallerymanagemodel.details.html';
export const ACCESSORY_CHECKBOX_PATH =
  '/environments/master/entries?contentTypeId=accessory-checkbox';
export const ALTERNATIVE_RULES_PATH = '/environments/master/entries?contentTypeId=alternativeRules';
export const ADVICE_BLOCK_PATH = '/environments/master/entries?contentTypeId=advice-block';
export const QUESTIONNAIRE_PATH = '/Questionnaire/edit.html';
export const NEGATIVE_KEYWORDS_PATH = '/keywords/negative';
export const POSITIVE_KEYWORDS_PATH = '/keywords';
export const COOLBLUES_CHOICE_PATH = '/Coolblues_Choice_Manager/edit.html#';
export const MARTINA_BASE_URL = 'https://martina.cool.blue';
export const GUIDO_BASE_URL = process.env.NEXT_PUBLIC_GUIDO_ENDPOINT;
